import authService from "./authService";

const API_URL = 'https://uni-func-pd-thrive360.azurewebsites.net/api/googleAnalyticsApi';

const googleAnalyticsService = {
  async authHeaders() {
    const idToken = await authService.getIdToken();
    return { Authorization: `Bearer ${idToken}` };
  },
  async getAnalyticsData(range = '14m') {
    try {
      const response = await fetch(`${API_URL}?range=${encodeURIComponent(range)}`, { headers: await this.authHeaders() });
      if (!response.ok) {
        throw new Error('Failed to fetch analytics data');
      }
      const data = await response.json();
      return {
        basicStats: data.basicStats || {
          pageViews: 0,
          uniqueUsers: 0,
          avgSessionDuration: '00:00:00',
          bounceRate: '0%'
        },
        topPages: data.topPages || [],
        userCountries: data.userCountries || [],
        userOrganizations: data.userOrganizations || [],
        deviceTypes: data.deviceTypes || [],
        realTimeData: data.realTimeData || {
          activeUsers: 0,
          currentPageViews: 0
        },
        appliedRange: data.appliedRange || range
      };
    } catch (error) {
      console.error('Error fetching analytics data:', error);
      return {
        basicStats: {
          pageViews: 0,
          uniqueUsers: 0,
          avgSessionDuration: '00:00:00',
          bounceRate: '0%'
        },
        topPages: [],
        userCountries: [],
        userOrganizations: [],
        deviceTypes: [],
        realTimeData: {
          activeUsers: 0,
          currentPageViews: 0
        },
        appliedRange: range
      };
    }
  },

  async getBasicStats(range = '14m') {
    const data = await this.getAnalyticsData(range);
    return data.basicStats;
  },

  async getTopPages(range = '14m') {
    const data = await this.getAnalyticsData(range);
    return data.topPages;
  },

  async getUserCountries(range = '14m') {
    const data = await this.getAnalyticsData(range);
    return data.userCountries;
  },

  async getUserOrganizations(range = '14m') {
    const data = await this.getAnalyticsData(range);
    return data.userOrganizations;
  },

  async getDeviceTypes(range = '14m') {
    const data = await this.getAnalyticsData(range);
    return data.deviceTypes;
  },

  async getRealTimeData() {
    try {
      const response = await fetch(API_URL, { headers: await this.authHeaders() });
      if (!response.ok) {
        throw new Error('Failed to fetch analytics data');
      }
      const data = await response.json();
      return data.realTimeData || {
        activeUsers: 0,
        currentPageViews: 0
      };
    } catch (error) {
      console.error('Error fetching real-time data:', error);
      return {
        activeUsers: 0,
        currentPageViews: 0
      };
    }
  }
};

export default googleAnalyticsService; 